import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, uncapitalize } from '~utils/helpers';
import { HTMLContent } from '../Content';

import DeadlineStyles from '../../utils/deadlineStyles';
import { deadlineStyle } from '../../utils/displayOptions';

function removeUpToDeadline(text) {
  // Match everything up to and including the first occurrence of "deadline"
  const regex = /^.*?deadline\s*/i;
  return text.replace(regex, '');
}

function DeadlineRelative({ relativeDeadline, lowercase, leadingWord = '' }) {
  if (!relativeDeadline || !relativeDeadline.text) {
    return null;
  }

  // If the html contains a link, we'll assume this isn't a straightforward deadline answer and the user needs to go elsewhere for details.
  // This path formats the answer for these unconventional answers. The pattern is currently based on Wisconsin's absentee_deadline_in_person value:
  // "The exact deadline varies by municipality. Please contact your Wisconsin clerk to find out more. Click here to find their contact information"
  if (relativeDeadline.html.includes('<a href')) {
    let content = removeUpToDeadline(relativeDeadline.html);
    content = lowercase ? content : capitalize(content);

    return (
      <HTMLContent content={content} className='inline' includePTags={false} />
    );
  }

  let deadlineType;

  if (relativeDeadline.text.toLowerCase().includes('received')) {
    deadlineType = 'received';
  } else if (relativeDeadline.text.toLowerCase().includes('postmarked')) {
    deadlineType = 'postmarked';
  }

  const deadlineDescriptionForDisplay = lowercase
    ? deadlineType
    : capitalize(String(deadlineType));

  if (
    deadlineStyle === DeadlineStyles.RELATIVE ||
    deadlineStyle === DeadlineStyles.BOTH
  ) {
    // replace any text related to received by / postmarked by, then grab everything before any parentheses
    const cleanedText = deadlineType
      ? uncapitalize(relativeDeadline.text)
          .replace(deadlineType, '')
          .replace('by', '')
          .split('(', 1)[0]
          .trim()
      : relativeDeadline.text;

    // render the deadlineDescriptionForDisplay if applicable, then a capitalized version of the cleaned text
    // (this will ensure things like a value of simply "Election Day" are capitalized)
    return (
      <>
        {deadlineType && `${leadingWord}${deadlineDescriptionForDisplay} by `}
        {`${leadingWord}${capitalize(cleanedText)}`}
      </>
    );
  }

  if (deadlineType && deadlineStyle === DeadlineStyles.SPECIFIC) {
    return `${leadingWord}${deadlineDescriptionForDisplay} by `;
  }

  return null;
}

DeadlineRelative.propTypes = {
  relativeDeadline: PropTypes.object,
  lowercase: PropTypes.bool,
  leadingWord: PropTypes.string,
};

DeadlineRelative.defaultProps = { lowercase: false };

export default DeadlineRelative;
